import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService, NbMenuItem } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActionState, BaseComponentConfig, ComponentConfig, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { baseMenuItems, options } from './configoptions';

@Component({
  selector: 'ubs-facilities',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./facilities.component.scss']
})
export class FacilitiesComponent extends BaseComponentConfig implements OnInit{
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    configurationService:ConfigurationService,
    route:ActivatedRoute,
    updateComponentStoreService:UpdateComponentStoreService,
    router:Router) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService);
    
   }
  
   ngOnInit(): void {
    console.log("Facilities are loaded")
    this.baseUrl = this.getBaseUrl();
/*     let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuTag = menuAndTitleOptions.menuTag;
    let menuItems:NbMenuItem[] = [];
    baseMenuItems.forEach(item => {
      menuItems.push(item);
    });
    this.menuService.addItems(menuItems,menuTag); */
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    options.defaultAction = ActionState.LIST;
    this.componentConfig = new ComponentConfig(options);
  }
}
